import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';
import { 
  BairrosDisponiveisResponse, 
  CidadesDisponiveisResponse, 
  ImoveisDisponiveisResponse, 
  ImovelDetalhesResposta, 
  LeadModel, 
  TiposImoveisPorDestinacaoResponse, 
  TiposImoveisResponse 
} from '../model/integracao';
import { environment } from '../../environments/environment.prod';
import { CondominioDetalhe } from '../model/imovel';

@Injectable({
  providedIn: 'root',
})
export class IntegracaoService {    
  public apiUrl = environment.urlApi;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient) {}

  private handleError(error: any) {
    console.error('Erro na requisição:', error);
    return throwError(() => new Error(error.message || 'Erro desconhecido na API'));
  }

  getTiposImoveisDisponiveis(): Observable<TiposImoveisResponse[]> {
    return this.http.get<TiposImoveisResponse[]>(
      `${this.apiUrl}Integracao/RetornarTiposImoveisDisponiveis`,
      { headers: this.headers }
    )
  }

  getTiposImoveisDisponiveisPorDestinacao(): Observable<TiposImoveisPorDestinacaoResponse[]> {
    return this.http.get<TiposImoveisPorDestinacaoResponse[]>(
      `${this.apiUrl}Integracao/RetornarTiposImoveisDisponiveisPorDestinacao`,
      { headers: this.headers }
    )
  }

  postCidadesDisponiveis(filtro: any): Observable<CidadesDisponiveisResponse[]> {
    return this.http.post<CidadesDisponiveisResponse[]>(
      `${this.apiUrl}Integracao/RetornarCidadesDisponiveis`,
      filtro,
      { headers: this.headers }
    )
  }

  postBairrosDisponiveis(filtro: any): Observable<BairrosDisponiveisResponse[]> {
    return this.http.post<BairrosDisponiveisResponse[]>(
      `${this.apiUrl}Integracao/RetornarBairrosDisponiveis`,
      filtro,
      { headers: this.headers }
    )
  }  

  postImoveisDisponiveisV2(filtro: any): Observable<ImoveisDisponiveisResponse> {
    return this.http.post<ImoveisDisponiveisResponse>(
      `${this.apiUrl}Integracao/RetornarImoveisDisponiveisV2`,
      filtro,
      { headers: this.headers }
    ) 
  }
  
  postImoveisDisponiveis(filtro: any): Observable<ImoveisDisponiveisResponse> {
    return this.http.post<ImoveisDisponiveisResponse>(
      `${this.apiUrl}Integracao/RetornarImoveisDisponiveis`,
      filtro,
      { headers: this.headers }
    ) 
  }

  getDetalhesImovelDisponivel(id: number): Observable<ImovelDetalhesResposta> {
    return this.http.get<ImovelDetalhesResposta>(
      `${this.apiUrl}Integracao/RetornarDetalhesImovelDisponivel/${id}`,
      { headers: this.headers }
    )
  }

  postNovoLead(filtro: LeadModel): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}Integracao/IncluirLeadCaptacao`,
      filtro,
      { headers: this.headers }
    );
  }

  getDetalhesCondominio(codigoCondominio: number): Observable<CondominioDetalhe> {
    return this.http.get<CondominioDetalhe>(
      `${this.apiUrl}Integracao/RetornarDetalhesCondominioDisponivel?codigoCondominio=${codigoCondominio}`,
      { headers: this.headers }
    );
  }
}
